import React from "react";
import {
  Class,
  JSTypeOperator,
  ObjectTypes,
} from "../../../../GenericCoreGraph/ClassFramework/Class";
import mainLogo from "../../../../../assets/img/edunet/loginEdu.png";
import Input from "@material-ui/core/Input";
import Actions from "../../../../GenericWebController/ActionGraph/Actions";
import GenericWebGraph from "../../../../GenericWebController/GenericWebGraph";
import { CommandIDs } from "../../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Lock from "@material-ui/icons/Lock";
import { withStyles } from "@material-ui/core/styles";
import GlobalStyles from "../../../../../ScriptStyles/GlobalStyles";
import Typography from "@material-ui/core/Typography";
import TBaseDialogModal from "../../../Utilities/TBaseDialogModal";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import { FormGroup } from "@material-ui/core";

var TLoginPageModal = Class(
  TBaseDialogModal, //CommandInterfaces.IShowMessageCommandReceiver, CommandInterfaces.IShowMessageAndRunCommandCommandReceiver,
  {
    ObjectType: ObjectTypes.Get("TLoginPageModal"),
    constructor: function (_Props) {
      TLoginPageModal.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        open: false,
        ButtonEnabled: true,
        UserName: "",
        Password: "",
        StaySession: false,
        selectedTimezone: null,
        loading: false,
      };
      window.App.LoginPageModal = this;
      document.addEventListener("keydown", this.HandleOnKeyUp);
    },
    Destroy: function () {
      TLoginPageModal.BaseObject.Destroy.call(this);
    },
    HandleUpdateInfo: function () {
      var __This = this;
      __This.HandleClose();
    },
    HandleOnKeyUp: function (event) {
      if (event.key === "Enter" && this.state.open) {
        this.HandleSubmit(event);
      }
    },
    HandleClickOpen: function (_ParamObject, _CallbackOnClose) {
      TLoginPageModal.BaseObject.HandleClickOpen.call(
        this,
        _ParamObject,
        _CallbackOnClose
      );
      var __This = this;
      this.CallbackOnClose = _CallbackOnClose;
      __This.setState({ loading: true });
      Actions.GetLoginCheck(function (_Message) {
        CommandIDs.ResultItemCommand.RunIfHas(_Message, function (_Data) {
          if (_Data.Item.UserOnline) {
            __This.Handle_ReturnFunction(true, _Message);
          } else {
            __This.setState({
              open: true,
              ButtonEnabled: true,
              UserName: "",
              Password: "",
              StaySession: false,
              selectedTimezone: null,
              loading: false,
            });
          }
        });
      });
    },
    HandleClose: function () {
      this.setState({
        open: false,
      });
      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    },
    HandleCloseLoading: function () {
      this.setState({
        loading: false,
      });
      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    },
    HandleOnChange: function (event, _Name) {
      if (_Name) {
        this.setState({ [_Name]: event.target.value });
      } else {
        this.setState({ [event.target.name]: event.target.value });
      }
    },
    HandleSubmit(event) {
      var __This = this;
      event.preventDefault();
      this.setState(
        {
          ButtonEnabled: false,
        },
        () => {
          Actions.Login(
            this.state.UserName,
            this.state.Password,
            this.state.StaySession,
            function (_Message) {
              CommandIDs.LogInOutCommand.RunIfHas(_Message, function (_Data) {
                __This.Handle_ReturnFunction(_Data.LoginState);
              });

              CommandIDs.LogInOutCommand.RunIfNotHas(
                _Message,
                function (_Data) {
                  __This.Handle_ReturnFunction(false);
                }
              );
            }
          );
        }
      );
    },
    Handle_ReturnFunction: function (_isLogined) {
      var __This = this;
      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;

        setTimeout(function () {
          __This.setState({
            open: false,
            loading: false,
          });
          __Function(_isLogined);
        }, 2000);
      }
    },
    HandleShowPassword: function () {
      var __Element = document.getElementById("passwordValue");
      if (__Element.type === "password") {
        __Element.type = "text";
      } else {
        __Element.type = "password";
      }
    },
    render: function () {
      const { classes } = this.props;
      var __Params = TLoginPageModal.BaseObject.render.call(this);
      if (!__Params.NeedRender) {
        return null;
      }
      return this.HandleWrapModal(
        <div>
          <DialogContent>
            <Grid container>
              <Grid xs={12} className={classes.mainGridPadding}>
                <Grid container className={classes.formAreaStyle}>
                  <Grid item sm={6} xs={0} className={classes.imageGridStyle}>
                    <img
                      style={{ height: "100%", width: "100%" }}
                      alt={mainLogo.alt}
                      src={mainLogo}
                      loading="lazy"
                      />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <div style={{ border: "unset" }}>
                      <FormGroup onSubmit={this.HandleSubmit}>
                        <h1 style={{ fontFamily: "Montserrat" }}>
                          {this.state.Language.SignIn}
                        </h1>
                        <p style={{ fontFamily: "Montserrat" }}>
                          {this.state.Language.LoginToYourAccount}
                        </p>
                        <Grid
                          container
                          spacing={1}
                          direction="row"
                          alignItems="flex-end"
                          style={{
                            flex: 1,
                            marginTop: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          <Grid item style={{ flex: 1 }}>
                            <FormControl className={classes.formElement2}>
                              <InputLabel
                                className={classes.labelStyle2}
                                htmlFor="standard-adornment-password"
                              >
                                {this.state.Language.Email}
                              </InputLabel>
                              <Input
                                autoComplete="off"
                                type={"text"}
                                className={classes.textFieldStyle}
                                value={this.state.email}
                                name={"email"}
                                onChange={(event) => {
                                  this.setState({
                                    UserName: event.target.value,
                                  });
                                }}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <MailOutlineIcon
                                      className={classes.iconStyle2}
                                    />
                                  </InputAdornment>
                                }
                                InputProps={{
                                  className: classes.input,
                                }}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          spacing={1}
                          direction="row"
                          alignItems="flex-end"
                          style={{
                            flex: 1,
                          }}
                        >
                          <Grid item style={{ flex: 1 }}>
                            <FormControl className={classes.formElement2}>
                              <InputLabel
                                className={classes.labelStyle2}
                                htmlFor="standard-adornment-password"
                              >
                                {this.state.Language.Password}
                              </InputLabel>
                              <Input
                                type={"password"}
                                autoComplete="off"
                                className={classes.textFieldStyle}
                                value={this.state.password}
                                name={"password"}
                                id="passwordValue"
                                onChange={(event) => {
                                  this.setState({
                                    Password: event.target.value,
                                  });
                                }}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <Lock
                                      onClick={() => {
                                        this.HandleShowPassword();
                                      }}
                                      className={classes.iconStyle2}
                                    />
                                  </InputAdornment>
                                }
                                InputProps={{
                                  className: classes.input,
                                }}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>

                        <div
                          className="text-left"
                          style={{
                            marginBlockStart: "10px",
                            textAlign: "left",
                          }}
                        >
                          <Button color="primary">
                            <Typography className={classes.forgotPassword}>
                              {this.state.Language.ForgotPassword}
                            </Typography>
                          </Button>
                        </div>

                        <div style={{ textAlign: "left" }}>
                          <FormControl className={classes.formElementCheck}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.StaySession}
                                  onChange={(event) => {
                                    this.setState({
                                      StaySession: event.target.checked,
                                    });
                                  }}
                                  name={this.state.Language.StaySession}
                                />
                              }
                              label={
                                <Typography className={classes.forgotPassword}>
                                  {this.state.Language.StaySession}
                                </Typography>
                              }
                            />
                          </FormControl>
                        </div>
                        <div style={{ padding: "3px" }}>
                          <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            disabled={!this.state.ButtonEnabled}
                            onClick={this.HandleSubmit}
                            block
                          >
                            <Typography className={classes.enterButton}>
                              {this.state.Language.Login}
                            </Typography>
                          </Button>
                        </div>
                        <Grid
                          container
                          style={{ marginTop: "10px" }}
                          spacing={1}
                        >
                          <Grid
                            item
                            xs={6}
                            style={{ margin: "auto", textAlign: "right" }}
                          >
                            <Typography className={classes.registerButton}>
                              {this.state.Language.RegisterInLogin}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{ margin: "auto", textAlign: "left" }}
                          >
                            <Button
                              color="primary"
                              onClick={() => {
                                if (window.App.GlobalParams.HeaderShow) {
                                  this.setState({ open: false }, () => {
                                    window.App.UnloginHeader.HandleSetUrl(
                                      window.App.GlobalParams.NetFrontRegisterUrl
                                    );
                                    GenericWebGraph.GoPage(
                                      window.App.GlobalParams.NetFrontRegisterUrl
                                    );
                                  });
                                } else {
                                  this.setState({ open: false }, () => {
                                    window.App.UnloginHeader.HandleSetUrl(
                                      window.Pages.Names.SellerRegisterPage
                                    );
                                    GenericWebGraph.GoPage(
                                      window.Pages.Names.SellerRegisterPage
                                    );
                                  });
                                }
                              }}
                            >
                              <Typography className={classes.registerButton}>
                                {this.state.Language.SignUp}
                              </Typography>
                            </Button>
                          </Grid>
                        </Grid>
                      </FormGroup>
                    </div>
                  </Grid>
                </Grid>
                <Grid item lg={2} md={1} sm={0} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions />
        </div>
      );
    },
  },
  {}
);

export default withStyles(GlobalStyles)(TLoginPageModal);
